"use client";

import { testimonials } from "@/data/landing";
import { TestimonialsSection } from "@/components/ui/testimonials-with-marquee";

const Testimonials = () => {
  return (
    <TestimonialsSection
      title="Testimonials"
      subtitle="Loved by early users"
      description="Here's what people are saying about Tavlo."
      testimonials={testimonials}
    />
  );
};

export default Testimonials;
